import useSWRImmutable from 'swr/immutable';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const useHeadToHeadOptions = (
    {
        crop,
        zoneIds,
        brandCodename,
        productId,
    }: { crop: string; zoneIds: number[]; brandCodename: string; productId?: number },
    { enabled }: { enabled?: boolean } = { enabled: true }
) => {
    let key = {
        key: 'useHeadToHeadOptions',
        crop,
        zoneIds,
        brandCodename,
        productId,
    };
    if (!crop || !zoneIds || zoneIds.length === 0 || !enabled) key = null;
    return useSWRImmutable(key, async ({ crop, zoneIds, brandCodename, productId }) => {
        const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/${crop}/h2h/heads/`, window.location.origin);
        const params = new URLSearchParams();
        params.append('zones', zoneIds.join(','));
        if (brandCodename) params.append('brand', brandCodename);
        if (productId) params.append('product_id', productId.toString());
        apiUrl.search = params.toString();

        const res = await axFetch.get(apiUrl.toString());
        return res.data.zones;
    });
};

export const useHeadToHeadEnvironments = ({ crop, headId, zoneId, brandsCodenames, altitude }) => {
    let key = { key: 'useHeadToHeadEnvironments', crop, headId, zoneId, brandsCodenames, altitude };
    if (!crop || !headId || !zoneId) key = null;
    return useSWRImmutable(key, async ({ crop, headId, zoneId, brandsCodenames, altitude }) => {
        if (!crop || !headId || !zoneId) return;
        const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/${crop}/h2h/environments/`, window.location.origin);
        const params = new URLSearchParams();
        params.append('head', headId);
        params.append('zone', zoneId);
        if (brandsCodenames) params.append('brands', brandsCodenames);
        if (altitude) params.append('altitude', altitude);
        apiUrl.search = params.toString();

        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    });
};

export const useHeadToHeadResults = ({ crop, headId, zoneId, brandsCodenames, maxEnv, minEnv, altitude }) => {
    let key = { key: 'useHeadToHeadResults', crop, headId, zoneId, brandsCodenames, maxEnv, minEnv, altitude };
    if (!crop || !headId || !zoneId) key = null;
    return useSWRImmutable(key, async ({ crop, headId, zoneId, brandsCodenames, maxEnv, minEnv, altitude }) => {
        if (!crop || !headId || !zoneId || maxEnv === undefined || minEnv === undefined) return;
        const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/${crop}/h2h/results/`, window.location.origin);
        const params = new URLSearchParams();
        params.append('head', headId);
        params.append('zone', zoneId);
        if (maxEnv) params.append('max_environment', maxEnv);
        if (minEnv) params.append('min_environment', minEnv);
        if (brandsCodenames) params.append('brands', brandsCodenames);
        if (altitude) params.append('altitude', altitude);
        apiUrl.search = params.toString();

        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    });
};
